module.exports = "/_next/static/images/JonWilburn-5fc3935ed45283a556b449e8852e94ee.webp";